<template>
  <div class="listvote">
    <div class="imgvotes">
      <van-swipe :autoplay="5000" indicator-color="#3562FF">
        <van-swipe-item>
          <img :src="billist.listCoverUrl" alt="" title="" />
        </van-swipe-item>
      </van-swipe>
      <div class="activity_details_swiper_span">
        <span class="page_data_item_img1" v-if="billist.listStatus == '未开始'">{{
          $t('message.home.t_start')
        }}</span>
        <span class="page_data_item_img2" v-else-if="billist.listStatus == '进行中'">{{
          $t('message.home.i_pro')
        }}</span>
        <span class="page_data_item_img3" v-else-if="billist.listStatus == '已结束'">{{
          $t('message.home.ended')
        }}</span>
      </div>
    </div>
    <div class="listvote_come">
      <div class="listvote_title">{{ billist.listTitle }}</div>
      <div class="listvote_pername">"{{ billist.listTitle }}{{ $t('message.solicitation') }}</div>
      <div class="listvote_bottom">
        <div class="listvote_item_surplus_day">
          {{ $t('message.home.surplus') }}<span>{{ billist.days ? billist.days : '0' }}</span
          >{{ $t('message.home.days') }}
        </div>
        <div class="listvote_item_solicitation_icon">
          <i class="icon-jr-icon-eye iconfont"></i>
          {{ billist.pageView }}
        </div>
      </div>
    </div>
    <h3 style="padding: 15px 15px 0px 15px; border-top: 10px solid #e8eaec">
      {{ $t('message.home.allreg') }}
    </h3>
    <div class="division">
      <div class="division_img_name" v-for="(item, index) in division" :key="index">
        <div class="dividion_citiy" @click="voteDivision(item.id)">
          <img :src="item.logoUrl" alt="" />
          <span class="division_item">{{ item.divisionName }}</span>
        </div>
        <div class="division_vote" v-if="item.vote">
          {{ $t('message.home.Voted') }}
        </div>
      </div>
    </div>
    <div class="home" @click="homeClick">
      <van-icon name="wap-home" style="font-weight: 600" color="#3562FF" />
    </div>
    <tab-bar-view @tabBarClick="tabBarClick" :indexNum="2" />
  </div>
</template>
<script>
import { Toast } from 'vant'

import { selectByListId, getByListId } from '@/api/common'
import TabBarView from '../../../components/TabBarView.vue'
import { getCookie } from '@/utils/cookie'

export default {
  components: {
    TabBarView
  },
  created() {
    console.log(this.ListVoteId)
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    this.selectByListId()
    this.getByListId()
  },
  data() {
    return {
      billist: [],
      division: []
    }
  },
  //监听属性 类似于data概念
  computed: {
    ListVoteId() {
      return this.$route.query.ListVoteId
    },
    id() {
      return this.$route.query.id
    }
    // activeState() {
    //   return this.$route.query.activeState
    // }
  },
  watch: {},
  //方法集合

  methods: {
    homeClick() {
      this.$router.push({
        name: 'Activity'
      })
    },
    tabBarClick(val) {
      if (val == 0) {
        this.$router.push({
          name: 'Works',
          query: { id: this.id }
        })
      } else if (val == 1) {
        if (this.activityData.activeState === 1) {
          this.showItem = false
          Toast.fail(this.$t('message.home.event_start'))
        } else if (this.activityData.activeState === 3) {
          this.showItem = false
          Toast.fail(this.$t('message.home.event_ended'))
        }
        let token = getCookie('token')
        if (token) {
          if (this.activityData.contributeTypeList.length === 1) {
            if (this.activityData.notSignUp) {
              if (this.activityData.activeState === 3) {
                Toast.fail(this.$t('message.home.event_ended'))
              } else {
                this.$router.push({
                  name: 'SignUp',
                  query: {
                    id: this.id,
                    index: this.activityData.contributeTypeList[0],
                    isWhether: this.isWhether
                  }
                })
              }
            } else {
              if (this.activityData.activeState === 3) {
                Toast.fail(this.$t('message.home.event_ended'))
              } else {
                this.$router.push({
                  name: 'UploadWorks',
                  query: {
                    id: this.id,
                    index: this.activityData.contributeTypeList[0],
                    isWhether: this.isWhether
                  }
                })
              }
            }
          } else {
            if (this.activityData.activeState === 2) {
              if (this.laseClick) {
                this.showItem = true
                this.laseClick = false
              } else {
                this.showItem = false
                this.laseClick = true
              }
            } else if (this.activityData.activeState === 1) {
              Toast.fail(this.$t('message.home.event_start'))
            } else if (this.activityData.activeState === 3) {
              Toast.fail(this.$t('message.home.event_ended'))
            }
          }
        } else {
          Toast.fail(this.$t('message.home.first_log'))
          setTimeout(() => {
            this.$router.push({
              name: 'Login'
            })
          }, 1000)
        }
      } else if (val == 2) {
        this.$router.push({
          name: 'ActivityDetails',
          query: { id: this.id }
        })
      }
    },
    async selectByListId() {
      const { data: res } = await selectByListId({ id: this.ListVoteId })
      console.log(res, '====')
      if (res.resultCode == 200) {
        this.billist = res.data
      }
    },
    async getByListId() {
      const { data: res } = await getByListId({ apiUserId: 1, listId: this.ListVoteId })
      if (res.resultCode == 200) {
        this.division = res.data
      }
    },
    voteDivision(divisionId) {
      this.$router.push({
        name: 'division',
        query: { listid: this.ListVoteId, divisionId: divisionId }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  width: 36px;
  height: 36px;
  position: fixed;
  top: 65%;
  display: flex;
  z-index: 999;
  right: 0;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #fff;
  border-radius: 50%;

  i {
    font-size: 24px;
  }
}

.imgvotes {
  width: 100%;
  overflow: hidden;
  height: 168px;
  position: relative;

  img {
    width: 100%;
    overflow: hidden;
    height: 168px;
  }
  span {
    position: absolute;
    display: block;
    width: 42px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    color: #fff;
    font-size: 10px;
    font-weight: 400;
    border-radius: 4px;
    left: 12px;
    top: 12px;
  }
  .page_data_item_img1 {
    background-color: #359eff;
  }

  .page_data_item_img2 {
    background-color: #fff;
    color: #3c3b3f;
  }

  .page_data_item_img3 {
    background-color: #bbbbbb;
  }
}

.listvote_come {
  width: 100%;
  z-index: 1;
  position: relative;
  overflow: hidden;
  padding: 10px 12px;
  border-radius: 12px 12px 0px 0px;
  background-color: #fff;
  box-sizing: border-box;
  margin-top: -30px;

  .listvote_title {
    width: 100%;
    overflow: hidden;
    color: #1a1a1a;
    font-size: 18px;
    line-height: 1.5em;
    font-weight: 600;
    margin-top: 6px;
  }

  .listvote_pername {
    font-size: 16px;
    color: #999999;
    margin: 15px 0;
  }

  .listvote_bottom {
    display: flex;
    justify-content: space-between;

    .listvote_item_surplus_day {
      color: #151515;
      font-size: 12px;
      font-weight: 400;

      span {
        display: inline-block;
        padding: 0 2px;
        margin: 0 4px;
        line-height: 18px;
        background-color: #f86363;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .listvote_item_solicitation_icon {
      display: flex;
      align-items: center;
      color: #c9c9c9;
      font-size: 12px;

      i {
        margin-right: 3px;
      }
    }
  }
}

.division {
  width: 100%;
  display: flex;
  //justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  .division_img_name {
    position: relative;
    margin: 8px;
    width: 28%;

    .division_vote {
      position: absolute;
      top: 30px;
      left: 26px;
      // width: 30px;
      padding: 0 3px;
      height: 17px;
      background: #d9d9d9;
      border-radius: 8px;
      font-size: 12px;
      text-align: center;
    }

    .dividion_citiy {
      display: flex;
      align-items: center;
      justify-content: center;

      .division_item {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        font-size: 13px;
      }
      img {
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>
